import LayoutItemView from "../../../layout/item-view/layout-item-view";


// DEPRECATED - Use ENUM below (!)
export const ITEM_VIEW_CRM_CONTACT: string          = 'iv-crm-contact'
export const ITEM_VIEW_CRM_ACCOUNT: string          = 'iv-crm-account'
export const ITEM_VIEW_TASK: string                 = 'iv-task'
export const ITEM_VIEW_DOCUMENT: string             = 'iv-document'
export const ITEM_VIEW_CHAT: string                 = 'iv-chat'
export const ITEM_VIEW_MEETING: string              = 'iv-meeting'
export const ITEM_VIEW_DISCUSSION: string           = 'iv-discussion'
export const ITEM_VIEW_REMINDER: string             = 'iv-reminder'
export const ITEM_VIEW_PROJECT_INFO: string         = 'iv-project-info'
export const ITEM_VIEW_PORTFOLIO_INFO: string       = 'iv-portfolio-info'
export const ITEM_VIEW_CUSTOM_VIEW_INFO: string     = 'iv-custom-view-info'
export const ITEM_VIEW_USER_INFO: string            = 'iv-user-info'
export const ITEM_VIEW_ATTACHMENT_PREVIEW: string   = 'iv-attachment-preview'
export const ITEM_VIEW_EVENT: string                = 'iv-event'
export const ITEM_VIEW_TIME_REPORT: string          = 'iv-time-report'
export const ITEM_VIEW_GOAL: string                 = 'iv-goal'
export const ITEM_VIEW_GOAL_INFO: string            = 'iv-goal-info'
export const ITEM_VIEW_EXPENSE: string              = 'iv-expense'
export const ITEM_VIEW_AUTOMATION: string           = 'iv-automation'
export const ITEM_VIEW_WIDGET: string               = 'iv-widget'
export const ITEM_VIEW_FROM_EDITOR: string          = 'iv-form-editor'
export const ITEM_VIEW_ANALYTICS: string            = 'iv-analytics'
export const ITEM_VIEW_EMAIL_TEMPLATE: string       = 'iv-email-template'
export const ITEM_VIEW_HISTORY: string              = 'iv-history'
export const ITEM_VIEW_GANTT_SNAPSHOT: string       = 'iv-gantt-snapshot'
export const ITEM_VIEW_EXTERNAL_ENTITY: string      = 'iv-external-entity'

export enum ItemViewType {
    ITEM_VIEW_CRM_CONTACT   = 'iv-crm-contact',
    ITEM_VIEW_REPORT        = 'iv-report',
    GD_NEWS                 = 'iv-gd-news',
    // etc...
}

// const debug = "ItemView"
const debug = false

export default class ItemView {

    views           : any[]
    layoutManager   : LayoutItemView | null

    constructor() {
        this.views = [];
        this.layoutManager = null;
    }

    get isOpen() {
        return this.views.length > 0
    }

    findByContainerId(containerId: string) {
        return _.find(this.views, (iv)=>iv.containerId===containerId);
    }

    _findById(itemViewId: string) {
        return _.find(this.views, (iv)=>iv.id===itemViewId);
    }

    findLast() {
        return _.last(this.views);
    }

    _modifyURL(options: any) {
        const lastView = this.findLast();

        // do something about the url
        if (options && (options.onAppLaunch || options.closeOnResize)) {
            // do nothing
        } else {
            if (lastView) {
                if (lastView.app.controller)    gd.setUrl(lastView.app.controller.routerPath,true);
                else                            gd.setUrl(lastView.app.routerPath,true);
            } else if (gd.getApp())             gd.setUrl(gd.getApp().routerPath,true); // update url and update main app if necessary
            else                                gd.goTo(''); // load main app if page initially loaded item view without background app
        }
    }

    async open(containerId: string, AppClass: any, options: any) {

        debug && console.log(debug, "open() containerId=", containerId)

        const existingViewOfThisType = this.findByContainerId(containerId);
        if (existingViewOfThisType) {
            this.views.remove(existingViewOfThisType); // remove view from views
            existingViewOfThisType.app.__destroy(); // destroy app
            this.layoutManager?.destroyContainer(existingViewOfThisType.containerId) // kill container
        }

        // generate itemViewId
        const itemViewId = gd.utils.generateUUID();

        // create new Container
        this.layoutManager?.createContainer(containerId);

        // create app
        const newApp = new AppClass(itemViewId, containerId);
        await newApp.init(options, gd.router.history.getPath());
        newApp.start(containerId);

        // register new app
        this.views.push({
            'id'            : itemViewId,
            'containerId'   : containerId,
            'app'           : newApp
        })

        this.layoutManager?.toggleContainerEmptyClass(this.views.length === 0);
    }

    close(itemViewId: string, options = {}) {

        debug && console.log(debug, "close() itemViewId=", itemViewId)

        const itemView = this._findById(itemViewId);

        // try to close item view that does not exist any more
        if (!itemView) return;

        // remove view from views
        this.views.remove(itemView)

        // before destroying trigger onClose for apps if method implemented
        if (itemView.app.onClose) itemView.app.onClose(options);
        // destroy app
        itemView.app.__destroy();

        // destroy container
        this.layoutManager?.destroyContainer(itemView.containerId);

        this.layoutManager?.toggleContainerEmptyClass(this.views.length === 0);

        // currently used in task-tray
        gd.bus.triggerEvent('item-view:close');

        this._modifyURL(options);
    }

    closeAll(options: any) {
        const viewIds = _.map(this.views, itemView=>itemView.id);

        _.map(viewIds, itemViewId=>{
            this.close(itemViewId, options);
        })
    }

    closeApp = (app: any) => {

        debug && console.log(debug, "closeApp() app=", app)


        if (app.onBeforeClose) {
            app.onBeforeClose(()=>{
                this.close(app.itemViewId)
            });
        } else {
            this.close(app.itemViewId)
        }
    }
}
